'use strict';

var Hosted = require('core/components/video/hosted');
var VideoModal = require('core/components/video/videoModal');
var videojs = require('video.js/dist/video.min.js');
var waterfall = {};
function enableHoverZoom() {
  var $zoomView = $('.zoom-view-dialog');
  $zoomView.find('div:not(.primary-images-main) .slide').each(function (index, slide) {
    var $slide = $(slide);
    if (!$slide.hasClass('no-zoom')) {
      var zoomImageUrl = $slide.data('zoom-image') || $slide.find('img').attr('src');
      var suppressClick = false;
      var startX = 0;
      var startY = 0;
      $slide.on('touchstart.waterfallZoom', function (e) {
        suppressClick = false;
        var touches = e.originalEvent.touches;
        if (touches.length === 1) {
          startX = touches[0].pageX;
          startY = touches[0].pageY;
        } else if (touches.length > 1) {
          suppressClick = true;
        }
      });
      $slide.on('touchmove.waterfallZoom', function (e) {
        var touches = e.originalEvent.touches;
        if (touches.length === 1) {
          var dx = Math.abs(touches[0].pageX - startX);
          var dy = Math.abs(touches[0].pageY - startY);
          if (dx > 10 || dy > 10) {
            suppressClick = true;
          }
        }
        if ($slide.hasClass('zoomed') && touches.length === 1) {
          e.preventDefault();
          $(document).trigger($.Event('mousemove.zoom', {
            pageX: touches[0].pageX,
            pageY: touches[0].pageY
          }));
        }
      });
      $slide.on('touchcancel.waterfallZoom', function () {
        suppressClick = true;
      });
      $slide.on('click.waterfallZoom', function (e) {
        if (suppressClick) {
          e.preventDefault();
          e.stopImmediatePropagation();
          suppressClick = false;
        }
      });
      $slide.zoom({
        url: zoomImageUrl,
        magnify: 1.25,
        touch: false,
        on: 'click',
        onZoomIn: function onZoomIn() {
          $(this).closest('.slide').addClass('zoomed');
        },
        onZoomOut: function onZoomOut() {
          $(this).closest('.slide').removeClass('zoomed');
        }
      });
    }
  });
}
waterfall.enableWaterfallZoomModal = function () {
  $('body').on('click', '.product-detail:not(.product-quickview) .product-img.btn, .product-detail:not(.product-quickview) .product-img-m.btn, .product-detail:not(.product-quickview) a.plus', function (e) {
    e.preventDefault();
    var $this = $(this);
    var currentIndex = $this.data('index');
    if ($('#zoomViewModal').length !== 0) {
      $('#zoomViewModal').remove();
    }
    var htmlString = '' + '<div class="modal fade" id="zoomViewModal" role="dialog">' + '<span class="enter-message sr-only" ></span>' + '<div class="modal-dialog zoom-view-dialog mw-100">' + '<!-- Modal content-->' + '<div class="modal-content">' + '<div class="modal-header">' + '    <button type="button" class="close pull-right" data-dismiss="modal">' + '        <span aria-hidden="true">&times;</span>' + '        <span class="sr-only"> </span>' + '    </button>' + '</div>' + '<div class="modal-body"></div>' + '</div>' + '</div>' + '</div>';
    $('body').append(htmlString);
    var $modal = $('#zoomViewModal');
    $modal.find('.modal-body').spinner().start();
    var $waterfallContainer = $('.waterfall-container');
    $modal.find('.modal-body').empty();
    var modalBodyString = '<!-- Images -->';
    var dImages = $waterfallContainer.find('div.slide > img.product-img');
    var currentIndexImageMarkup = '';
    var otherImagesMarkup = '';
    Array.from(dImages).forEach(function (dImage, idx) {
      var isCurrentIndex = currentIndex === $(dImage).data('index');
      var zImageUrl = $(dImage).parent().data('zoom-image');
      var imgMarkup = '<div class="slide col-12 d-block">' + '<a class="plus plus-lg text-center"><div class="icon-zoom before"></div></a>' + '<img class="col-12 product-img" src="' + zImageUrl + '" alt="image number ' + (idx + 1) + '" />' + '</div>';
      if (isCurrentIndex) {
        currentIndexImageMarkup += imgMarkup;
      } else {
        otherImagesMarkup += imgMarkup;
      }
    });
    modalBodyString = currentIndexImageMarkup + otherImagesMarkup;
    $modal.find('.modal-body').html(modalBodyString);
    $modal.modal('show');
    $.spinner().stop();
    enableHoverZoom();
  });
  $('body').off('waterfall:seemore').on('waterfall:seemore', function (e, target) {
    var $trigger = $(target);
    var $container = $trigger.parents('.waterfall-container');
    $container.find('.waterfall-extra-images').addClass('d-md-block');
    $container.find('.waterfall-fade-overlay').removeClass('d-md-block');
    $trigger.removeClass('d-md-block');
  });
  $('body').off('click', '.waterfall-see-more').on('click', '.waterfall-see-more', function (e) {
    e.preventDefault();
    $('body').trigger('waterfall:seemore', this);
  });
};
module.exports = waterfall;